

















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class ListItem extends Vue {
  @Prop({ type: String }) text?: string;
  @Prop({ type: String }) icon?: string;
  @Prop({ type: String }) iconColor?: string;

  @Prop({ type: Boolean, default: false }) nav!: boolean;
  @Prop({ type: Boolean, default: false }) withoutChevron!: boolean;
}
